export type ConversionErrorCode =
  | 'unsupported-format'
  | 'invalid-file'
  | 'file-too-large'
  | 'image-too-large'
  | 'gif-too-many-frames'
  | 'gif-too-long'
  | 'gif-dimensions-too-large'
  | 'canvas-allocation'
  | 'decode-failed'
  | 'encode-failed'
  | 'cancelled';

export class ConversionError extends Error {
  readonly code: ConversionErrorCode;

  constructor(code: ConversionErrorCode, message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'ConversionError';
    this.code = code;
  }
}

export function messageFromUnknown(error: unknown): string {
  return error instanceof Error ? error.message : 'An unexpected error occurred.';
}
